export const container = `px-0 h-4 text-sm w-full justify-start text-nowrap`;
export const icon = `w-3 h-3 -mb-0.5`;
